<template>
  <header>
    <!--       <iframe style="position:absolute;top:0px" scrolling="no" src="https://tianqiapi.com/api.php?style=tj&skin=pitaya&color=ff00ff" frameborder="0" width="450" height="100%" allowtransparency="false"></iframe>-->
    <!--        <iframe style="position:absolute;top:0px" scrolling="no" src="https://tianqiapi.com/api.php?style=tt&skin=pitaya&color=ff00ff" frameborder="0" width="490" height="98" allowtransparency="true"></iframe>-->
    <iframe
      :class="{ weather: display }"
      style="position: absolute; top: 10px; z-index: -1000"
      scrolling="no"
      src="https://tianqiapi.com/api.php?style=tg&skin=pitaya&column=1&color=AB5F87&paddingleft=0"
      frameborder="0"
      width="460"
      height="60"
      allowtransparency="true"
    ></iframe>
    <div id="box">
      <!--            <div class="title">-->
      <!--<div class="logo" @click="handleClick"></div>-->
      <!--                &lt;!&ndash;            <img src="../assets/logo.png" style="width: 60px;height: 30px;">&ndash;&gt;-->

      <!--            </div>-->
      <ul>
        <li class="logo" @click="handleClick('http://www.lvwang.org.cn/')"></li>
        <li>
          <el-tooltip class="item" effect="dark" placement="top">
            <span slot="content" style="font-size: 10px; line-height: 25px"
              >数据来源：环境影响评价信用平台(http://114.251.10.92:8080/XYPT/)<br
            /></span>
            <span style="font-size: 20px; margin-right: 30px" @click="handleClick('http://114.251.10.92:8080/XYPT/')"
              >环评信用平台数据分析</span
            >
          </el-tooltip>
        </li>

        <li :class="{ active: currentPage === '/index' }" @click="changePage('/index')">
          <span>首页</span>
          <!--                    <router-link to="
                /credit-project"></router-link>-->
        </li>
        <li
          :class="{ active: currentPage === '/v2/credit-project/realtime' }"
          @click="changePage('/v2/credit-project/realtime')"
        >
          <span>实时数据</span>
          <!--                    <router-link to="
                /credit-project"></router-link>-->
        </li>
        <li
          :class="{ active: currentPage === '/v2/credit-project/project-analysis' }"
          @click="changePage('/v2/credit-project/project-analysis')"
        >
          <span>项目统计分析</span>
          <!--                    <router-link to="
                /credit-project">土壤</router-link>-->
        </li>
        <li
          :class="{ active: currentPage === '/v2/credit-project/compile-unit-analysis' }"
          @click="changePage('http://www.lvwang.org.cn/pages/hpxy.html')"
        >
          <span>编制单位分析</span>
          <!--                    <router-link to="
                /credit-project">水源</router-link>-->
        </li>
        <li
          :class="{ active: currentPage === '/v2/credit-project/compile-host-analysis' }"
          @click="changePage('http://www.lvwang.org.cn/pages/hpxy.html')"
        >
          <span>主持人分析</span>
          <!--                    <router-link to="/credit-project">-->
          <!--                    </router-link>-->
        </li>
        <li
          :class="{ active: currentPage === '/v2/credit-project/public-supervision' }"
          @click="changePage('http://www.lvwang.org.cn/pages/hpxy.html')"
        >
          <span>公众监督</span>
          <!--                    <router-link to="
                /credit-project">数据查询</router-link>-->
        </li>
        <li
          :class="{ active: currentPage === '/v2/credit-project/data-search' }"
          @click="changePage('/v2/credit-project/data-search')"
        >
          <span>数据查询</span>
          <!--                    <router-link to="
                /credit-project">数据说明</router-link>-->
        </li>
        <!--                <li :class="{active: currentPage === '/credit-project/realtime' }" @click="change()">-->
        <!--                    <span>旧版本</span>-->
        <!--                    &lt;!&ndash;                    <router-link to="-->
        <!--                /credit-project">数据说明</router-link>&ndash;&gt;-->
        <!--                </li>-->
      </ul>
    </div>
    <div class="btn-fullscreen" @click="handleFullScreen">
      <el-tooltip effect="dark" :content="fullscreen ? `取消全屏` : `全屏`" placement="bottom">
        <i class="el-icon-rank" style="font-size: 26px"></i>
      </el-tooltip>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Nav2',

  data() {
    return {
      currentPage: '',
      fullscreen: false,
      display: true
    }
  },
  methods: {
    handleFullScreen() {
      let element = document.documentElement
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen()
        }
      }
      this.fullscreen = !this.fullscreen
    },
    handleClick(url) {
      window.open(url)
    },
    changePage(url) {
      if (url.indexOf('/') === 0) {
        this.$router.push(url)
      } else {
        window.open(url)
      }
    },
    change() {
      var url = 'http://47.115.168.13:8070'
      window.open(url)
    }
  },
  created() {
    this.currentPage = this.$route.path
    window.addEventListener('scroll', () => {
      let header = document.querySelector('header')
      header.classList.toggle('sticky', window.scrollY > 0)
    })
    this.fullWidth = document.documentElement.clientWidth
    if (this.fullWidth <= 1750) {
      this.display = true
    } else {
      this.display = false
    }
  },
  mounted() {}
}
</script>

<style scoped>
.weather {
  display: none;
}

.btn-fullscreen {
  position: absolute;
  right: 40px;
  color: #ff00ff;
}

.btn-fullscreen:hover {
  cursor: pointer;
  color: #52dbf5;
}

#box {
  margin-left: auto;
  margin-right: auto;
  /*min-width: 1200px;*/
  /*background-color: #8cc5ff;*/
}

/*.title {*/
/*    !*position: relative;*!*/
/*    font-size: 22px;*/
/*    margin-right: 50px;*/
/*    margin-top: -10px;*/
/*    float: left*/
/*}*/

.logo {
  width: 70px;
  height: 35px;
  /*margin-top: -15px;*/
  background: url('../../assets/logo_change2.png');
  background-size: 100% 100%;
  float: left;
}

.logo:hover {
  cursor: pointer;
  background-size: 106% 106%;
}

header.sticky .logo {
  width: 70px;
  height: 35px;
  /*margin-top: 5px;*/
  background: url('../../assets/logo_puple.png');
  background-size: 100% 100%;
  float: left;
}

/*header.sticky .logo:hover {*/

/*    cursor: pointer;*/
/*    background-size: 106% 106%;*/

/*}*/

/*.title img {*/
/*    position: relative;*/
/*    margin-top: 10px;*/
/*    float: left;*/
/*}*/

/*.title span {*/
/*    position: relative;*/
/*    !*display: flex;*!*/
/*    float: right;*/
/*    margin-left: 10px;*/
/*}*/

header {
  user-select: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  /*justify-content: space-between;*/
  /*align-items: center;*/
  transition: 0.6s;
  /*padding-right: 50px;*/
  /*padding-left: 50px;*/
  padding: 30px 0px;
  color: #f7f7b6;
  z-index: 1000;
  font-weight: bold;
}

header.sticky {
  padding: 10px 0px;
  background: #ffffff;
  box-shadow: 2px 2px 1px #f7f7b6;
}

header.sticky ul li span {
  /*font-weight: bold;*/
  color: #ab5f87;
}

header ul li span {
  /*font-weight: bold;*/
}

header.sticky .title {
  color: #ab5f87;
}

header img {
  position: relative;
  transition: 0.6s;
}

header ul {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  float: right;
}

header ul li {
  position: relative;
  list-style: none;
  padding-bottom: 5px;
}

header ul li span {
  position: relative;
  margin: 0 10px;
  font-size: 16px;
  /*font-weight: bold;*/
  transition: 0.5s;
}

header ul li:hover {
  /*color: #f7f7f7;*/
  cursor: pointer;
  border-bottom: 2px solid #f7f7b6;
}

header.sticky ul li:hover {
  /*color: #f7f7f7;*/
  cursor: pointer;
  border-bottom: 2px solid #ab5f87;
}

header ul li.active {
  /*color: #f7f7f7;*/
  border-bottom: 2px solid #f7f7b6;
}

header.sticky ul li.active {
  color: #f7f7b6;
  border-bottom: 2px solid #ab5f87;
}
</style>
